<template>
    <mini-calculator-page>
        <div slot="summary-panel" class="flex-grid--vertical">
            <div class="p-animated-calc__results a-form-inputs u-full-width u-margin-auto">
                <mini-calculator-header title="Age Calculator" icon="age-calculator"/>

                <div>
                    <control for="deceased_date_of_birth" label="Date of Birth">
                        <date-input ref="deceasedDateOfBirth"
                                    v-model="dateOfBirth" @change="updateCounter(totalInputs + 1)"
                                    v-field-control:deceased_date_of_birth.required="{type:'date'}"
                                    @input="handler"></date-input>
                        <control-error :show="$error('deceased_date_of_birth')">
                            The date of birth is required and must be in the format DD/MM/YYYY
                        </control-error>
                    </control>
                    <control for="deceased_date_of_death" label="Date of Death">
                        <date-input ref="deceasedDateOfDeath"  v-model="dateOfDeath" @change="updateCounter(totalInputs + 1)"
                                    v-field-control:deceased_date_of_death.required="{type:'date', rules:dateOfDeathRules}"
                                    @input="handler"></date-input>
                        <control-error :show="$error('deceased_date_of_death')">
                            The date of death is required and must be in the format DD/MM/YYYY
                        </control-error>
                    </control>
                </div>

                <h2 class="u-r-margin-top-40">
                    Result
                </h2>

                <control for="age_at_death" label="Age at Death">
                    <input autocomplete="off" disabled="disabled"
                           id="age_at_death" type="number"
                           name="age_at_death"
                           v-two-dp
                           v-model="ageAtDeath">
                </control>
            </div>
        </div>

        <div slot="results-panel" class="flex-grid--vertical" v-show="ageAtDeath">
            <div class="p-animated-calc__results-panel u-full-width u-margin-auto">
                <h2>Explanation</h2>

                <p>
                    The age at death calculator has determined the age for a person who was
                    born on {{ dateOfBirth }} and who died on {{ dateOfDeath }} as {{ ageAtDeath }} years old.
                    <br><br>
                </p>

                <value-bars :values="barValues">
                    <h3>Age at Date of Death &mdash; {{ dateOfDeath }}</h3>
                    <div class="m-bars__bar bar1"><span></span></div>
                    <h3>Age at Today's Date &mdash; {{ todaysDate }}</h3>
                    <div class="m-bars__bar bar2"><span></span></div>
                </value-bars>

                <p>
                    <br><br>
                    <strong>
                        Perhaps try our
                        <router-link :to="'/mini-calculators/life-expectancy'">Life Expectancy Calculator</router-link>
                        in order to see how the person's life expectancy compares to the figures provided here.
                    </strong>
                </p>
            </div>
        </div>
    </mini-calculator-page>
</template>

<script type="text/babel">
    import Vue from 'vue';
    import moment from 'moment';
    import {mapGetters, mapActions} from 'vuex';
    import MiniCalculatorPage from 'pages/mini-calculators/components/MiniCalculatorPage';
    import miniCalcIcons from 'components/Icons.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import DateInput from 'components/form/control/DateInput.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Intro from 'pages/mini-calculators/calculators/CalculatorComponents/Intro';
    import CalculatorKeyBindings from 'pages/mini-calculators/calculators/mixins/MiniCalculatorBindings';
    import ValueBars from 'components/form/ValueBars';
    import roundValue from 'mixins/roundValue';
    import MiniCalculatorHeader from 'pages/mini-calculators/components/MiniCalculatorHeader';

    export default {
        name: 'age-calculator',
        computed: {
            ...mapGetters('mini/age', {detailValue: 'value'}),
            todaysDate: {
                get() {
                    return moment().format('DD/MM/YYYY');
                }
            },
            dateOfBirth: {
                get() {
                    return this.detailValue('dateOfBirth');
                },
                set(value) {
                    this.updateDetail({key: 'dateOfBirth', value});
                }
            },
            dateOfDeath: {
                get() {
                    return this.detailValue('dateOfDeath');
                },
                set(value) {
                    this.updateDetail({key: 'dateOfDeath', value});
                }
            },
            ageAtDeath: {
                get() {
                    let ageAtDeath = this.detailValue('age');

                    if (ageAtDeath) {
                        this.hidePrompt();
                    }

                    return ageAtDeath;
                },
            },
            barValues: {
                get() {
                    return [
                        this.roundValue(moment(this.dateOfDeath, 'DD/MM/YYYY')
                            .diff(moment(this.dateOfBirth, 'DD/MM/YYYY'), 'days', false) / 365.25, 2),
                        this.roundValue(moment(this.todaysDate, 'DD/MM/YYYY')
                            .diff(moment(this.dateOfBirth, 'DD/MM/YYYY'), 'days', false) / 365.25, 2),
                    ];
                }
            },
            dateOfDeathRules() {
                return "min:" + moment(this.assumedSettlement, 'DD/MM/YYYY').subtract(9, 'years').format('DD/MM/YYYY') + "|"
                    + "max:" + this.assumedSettlement;
            }
        },
        mixins: [
            FormValidator,
            CalculatorKeyBindings,
            roundValue
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            Control,
            ControlError,
            DateInput,
            Intro,
            MiniCalculatorPage,
            MiniCalculatorHeader,
            miniCalcIcons,
            ValueBars,
        },
        data: function () {
            return {
                value: 0,
            }
        },
        created() {
            this.resetForm()
        },
        methods: {
            ...mapActions('mini/age', {
                calculateAge: 'calculateAge',
                updateDetail: 'update',
                resetForm: 'reset'
            }),
            calcAge() {
                this.calculateAge();
            },
            handler: function () {
                this.calcAge();

                if (!this.$valid()) {
                    return;
                }

                this.hidePrompt();
            },

        },
    }
</script>



// WEBPACK FOOTER //
// ageCalculator.vue?0c984bee